"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Design = function Design(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "DesignTitle DesignDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "DesignTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "DesignDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(0.75 0.75)",
    d: "M24.778 21.862a1.267 1.267 0 1 0 0 2.534 1.267 1.267 0 0 0 0-2.534zm-10.716 6.125h10.894a4.582 4.582 0 0 0 4.577-4.596V14.44h-15.47v13.547zm1.111-12.445h13.25v7.85a3.471 3.471 0 0 1-3.467 3.461h-9.778l-.005-11.31zM2.591 27.987h9.542V3.91H2.591v24.076zM3.702 5.044h7.32v21.81h-7.32V5.043zm10.36-1.133v8.551h15.471v-8.55h-15.47zm14.36 7.44H15.173V5.022h13.25v6.33z",
    id: "refDesign-0IeusGq2SRC"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refDesign-0IeusGq2SRC"
  }));
};

Design.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Design.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Design;
exports["default"] = _default;